import { referenceTooltip } from "./referenceHelpers";

/**
 * A reference as a small link that opens its source in a new tab, or as plain
 * text when it has no link. The tooltip carries the title and the note.
 *
 * @param {object} props
 * @param {import("./referencesApi").GhgReference|null} props.reference
 * @param {string} [props.label] what to show instead of the title, e.g. "GWP"
 */
export default function ReferenceLink({ reference, label }) {
  if (!reference) return null;
  const text = label || reference.title;
  const tooltip = referenceTooltip(reference);
  if (!reference.url) {
    return (
      <span className="efb-ref" title={tooltip}>
        {text}
      </span>
    );
  }
  return (
    <a className="efb-ref" href={reference.url} target="_blank" rel="noopener noreferrer" title={tooltip}>
      {text}
      <span aria-hidden="true"> ↗</span>
    </a>
  );
}
